// extracted by mini-css-extract-plugin
export var alt = "NotAvailableMessage-module--alt--bfccc";
export var container = "NotAvailableMessage-module--container--b409b";
export var desktopOnly = "NotAvailableMessage-module--desktopOnly--93c5a";
export var main = "NotAvailableMessage-module--main--1e539";
export var mobileOnly = "NotAvailableMessage-module--mobileOnly--307e8";
export var textLeft = "NotAvailableMessage-module--textLeft--6004f";
export var visuallyHidden = "NotAvailableMessage-module--visuallyHidden--a5f1c";